<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(221,114,2); 
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Expression
        </p>
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
                In this visualization section, we selected some representative <strong style="font-size:20px;"> gene and CpG site expression datasets of MDD</strong>. 
                The samples are from the brain or blood tissues.
                <br/>When you select a dataset and enter the gene/probe you want to query, you will get a boxplot of the gene/CpG site expression in the case and control groups to compare whether the gene/CpG site is differentially expressed in the patient.
                <br/>In addition to the box plot, you can also view the information of each sample through the scatter over the box plot.
               </div>
        </el-card>
       <el-tabs style="height:auto;margin-top: 50px;" type="border-card" v-model="activePane">
        <el-tab-pane label="Gene expression" name="gene">
            <div style="width:30%;height:auto;display: inline-block;vertical-align: middle;">
                    Select an expression data set: <br/>
                    <el-select v-model="activeDataset" placeholder="Choose type" style="display: inline-block;width: 80%;">
                        <el-option
                            v-for="item in geneOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <br/><br/>
                    Enter single gene name here: <br/>
                <input type="text" placeholder="Enter single gene name here" v-model="searchGene" style="height:35px;width:80%">
                <br/><br/>
                <el-button size="small" @click="getData()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:80%;height:40px;">Submit</el-button>
            </div>

            <el-descriptions :column="3" style="width: 69%;display: inline-block;vertical-align:middle;" border>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >GEO accession</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc='+this.activeData[this.activeDataset].accession">    {{this.activeData[this.activeDataset].accession}}   </a>
                    </template>
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Case and Control</template>
                    {{this.activeData[this.activeDataset].sample}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Tissue</template>
                    {{this.activeData[this.activeDataset].tissue}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Gender</template>
                    {{this.activeData[this.activeDataset].gender}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Age</template>
                    {{this.activeData[this.activeDataset].age}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >PMID</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">    {{this.activeData[this.activeDataset].pmid}}   </a>
                    </template>
                </el-descriptions-item>     
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Citation</template>
                    {{this.activeData[this.activeDataset].citation}} 
                </el-descriptions-item>
            </el-descriptions>  
            <div id="boxplotGene">
                <BoxplotchartVue :jsonData="jsonData" 
                    :title="activeData[activeDataset].array" 
                    :value_type='activeData[activeDataset].value_type '
                    :tooltip='activeData[activeDataset].tooltip'
                    :plotTitle="title"></BoxplotchartVue>
            </div> 
            
        </el-tab-pane>
        <el-tab-pane label="Methylation site expression" name="methylation">
            <el-card class="box-card" 
            style="height:auto;
            width:100%;
            background-color: rgba(255,208,75,0.05);
            font-size: 16px;
            margin-bottom: 5%;">
                <p>If you don't know which probe ID the gene you want to search corresponds to in certain dataset, you can do a mapping first.</p>
                 Platform:
                <el-select v-model="mapDataset" placeholder="Choose type" style="display: inline-block;width: 25%;">
                    <el-option
                        v-for="item in platformOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            Gene name:
            <input type="text" id="inputSearch" placeholder="Enter single gene name here" v-model="mapGene" style="height:35px;width:20%;">
           
            <el-button size="small" @click="map()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:20%;height:40px;">Map</el-button>    
            <br/><br/>Result: <input type="text" placeholder="The result will show here." v-model="mapResult" style="height:35px;width:75%;"/>
        </el-card>
            
            <div style="width:30%;height:auto;display: inline-block;vertical-align: middle;">
                    Select an expression data set: <br/>
                    <el-select v-model="activeDataset" placeholder="Choose type" style="display: inline-block;width: 80%;">
                        <el-option
                            v-for="item in methylationOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <br/><br/>
                    Enter single probe ID here: <br/>
                <input type="text" placeholder="Enter single probe ID here" v-model="searchMethylation" style="height:35px;width:80%">
                <br/><br/>
                <el-button size="small" @click="getData()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:80%;height:40px;">Submit</el-button>
            </div>

            <el-descriptions :column="3" style="width: 69%;display: inline-block;vertical-align:middle;" border>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >GEO accession</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc='+this.activeData[this.activeDataset].accession">    {{this.activeData[this.activeDataset].accession}}   </a>
                    </template>
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Case and Control</template>
                    {{this.activeData[this.activeDataset].sample}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Tissue</template>
                    {{this.activeData[this.activeDataset].tissue}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Gender</template>
                    {{this.activeData[this.activeDataset].gender}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Age</template>
                    {{this.activeData[this.activeDataset].age}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >PMID</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">    {{this.activeData[this.activeDataset].pmid}}   </a>
                    </template>
                </el-descriptions-item>     
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Citation</template>
                    {{this.activeData[this.activeDataset].citation}} 
                </el-descriptions-item>
            </el-descriptions>   
            <div id="boxplotMethylation" >
                <BoxplotchartVue :jsonData="jsonData" 
                    :title="activeData[activeDataset].array" 
                    :value_type='activeData[activeDataset].value_type '
                    :tooltip='activeData[activeDataset].tooltip'
                    :plotTitle="title"></BoxplotchartVue>
            </div>


        </el-tab-pane>
       </el-tabs>
       
        
    </div>
</template>
<script>
import{Loading}from'element-ui';
import BoxplotchartVue from '../../chart/Boxplotchart.vue'
export default ({
    data(){
        return{
            geneOption:[{
                value: 'GSE98793-batch1',
                label: 'GSE98793-batch1(blood)'
            },{
                value: 'GSE98793-batch2',
                label: 'GSE98793-batch2(blood)'
            },{
                value: 'GSE102556-BA11',
                label: 'GSE102556-BA11(brain)'
            },{
                value: 'GSE102556-aINS',
                label: 'GSE102556-aINS(brain)'
            },{
                value: 'GSE102556-BA8_9',
                label: 'GSE102556-BA8_9(brain)'
            },{
                value: 'GSE102556-Cg25',
                label: 'GSE102556-Cg25(brain)'
            },{
                value: 'GSE102556-Nac',
                label: 'GSE102556-Nac(brain)'
            },{
                value: 'GSE102556-Sub',
                label: 'GSE102556-Sub(brain)'
            },],
            methylationOption:[{
                value: 'GSE201287',
                label: 'GSE201287(blood)'
            },{
                value: 'GSE88890-BA11',
                label: 'GSE88890-BA11(brain)'
            },{
                value: 'GSE88890-BA25',
                label: 'GSE88890-BA25(brain)'
            }],
            platformOption:[{
                value: 'GPL13534',
                label: 'GPL13534 Illumina HumanMethylation450 BeadChip'
            }],
            activePane:'gene',
            
            searchGene:"BDNF",
            searchMethylation:"cg00000029",
            activeDataset:'GSE98793-batch1',
            
            mapDataset:'GPL13534',
            mapGene:"BDNF",

            activeData:{
                // gene
                'GSE98793-batch1':{
                    'array':['value','gene_name','sample','age','anxiety','batch','gender','type','tissue'],
                    'value_type':'log2 GC-RMA signal',
                    'tooltip':['sample', 'value','age','anxiety','gender'],
                    'accession':'GSE98793',
                    'sample':'Case-64\nControl-32',
                    'tissue':'Whole blood',
                    'gender':'Female-72\nMale-24',
                    'age':'50.74±11.18',
                    'platform':'GPL570',
                    'pmid':'28688579',
                    'citation':'Leday GGR, Vértes PE, Richardson S, Greene JR et al. Replicable and Coupled Changes in Innate and Adaptive Immune Gene Expression in Two Case-Control Studies of Blood Microarrays in Major Depressive Disorder. Biol Psychiatry 2018 Jan 1;83(1):70-80.',
                },
                'GSE98793-batch2':{
                    'array':['value','gene_name','sample','age','anxiety','batch','gender','type','tissue'],
                    'value_type':'log2 GC-RMA signal',
                    'tooltip':['sample', 'value','age','anxiety','gender'],
                    'accession':'GSE98793',
                    'sample':'Case-64\nControl-32',
                    'tissue':'Whole blood',
                    'gender':'Female-72\nMale-24',
                    'age':'53.34±11.62',
                    'platform':'GPL570',
                    'pmid':'28688579',
                    'citation':'Leday GGR, Vértes PE, Richardson S, Greene JR et al. Replicable and Coupled Changes in Innate and Adaptive Immune Gene Expression in Two Case-Control Studies of Blood Microarrays in Major Depressive Disorder. Biol Psychiatry 2018 Jan 1;83(1):70-80.',
                },
                'GSE102556-BA11':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Orbitofrontal (OFC; BA11)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-BA8_9':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Dorsolateral prefrontal cortex (dlPFC; BA8/9)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Cg25':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-13\nControl-15',
                    'tissue':'Cingulate gyrus 25 (Cg25)',
                    'gender':'Female-17\nMale-11',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-aINS':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Anterior Insula (aINS)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Nac':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Nucleus Accumbens (Nac)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Sub':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-24\nControl-19',
                    'tissue':'Subiculum (Sub)',
                    'gender':'Female-19\nMale-24',
                    'age':'45.91±13.49',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },


                // methylation
                'GSE201287':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE201287',
                    'sample':'Case-40\nControl-40',
                    'tissue':'Blood',
                    'gender':'Female-44\nMale-36',
                    'age':'30.03±12.43',
                    'platform':'GPL13534',
                    'pmid':'35858435',
                    'citation':'Xiu J, Li J, Liu Z, Wei H et al. Elevated BICD2 DNA methylation in blood of major depressive disorder patients and reduction of depressive-like behaviors in hippocampal Bicd2-knockdown mice. Proc Natl Acad Sci U S A 2022 Jul 26;119(30):e2201967119.',
                },
                'GSE88890-BA11':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE88890',
                    'sample':'Case-20\nControl-20',
                    'tissue':'cortex, Brodmann area 11',
                    'gender':'Female-9\nMale-31',
                    'age':'43.98±20.4',
                    'platform':'GPL13534',
                    'pmid':'28045465',
                    'citation':'Murphy TM, Crawford B, Dempster EL, Hannon E et al. Methylomic profiling of cortex samples from completed suicide cases implicates a role for PSORS1C3 in major depression and suicide. Transl Psychiatry 2017 Jan 3;7(1):e989.',
                },
                'GSE88890-BA25':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE88890',
                    'sample':'Case-17\nControl-18',
                    'tissue':'cortex, Brodmann area 11',
                    'gender':'Female-8\nMale-27',
                    'age':'45.23±21.13',
                    'platform':'GPL13534',
                    'pmid':'28045465',
                    'citation':'Murphy TM, Crawford B, Dempster EL, Hannon E et al. Methylomic profiling of cortex samples from completed suicide cases implicates a role for PSORS1C3 in major depression and suicide. Transl Psychiatry 2017 Jan 3;7(1):e989.',
                },
            },
            jsonData:[],
            mapResult:null,
            title:null,
        }
    },
    watch:{
        activePane:function(){
            this.jsonData=[]
            if(this.activePane=='gene')
                this.activeDataset='GSE98793-batch1'
            else this.activeDataset='GSE201287'
            this.getData()
        }
    },
    components:{
        BoxplotchartVue
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            if(this.activePane=='gene'){
                var loadingInstance = Loading.service({
                    target:document.querySelector('#boxplotGene')
                });
                this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/gene',{
                params: { 
                    'geo':this.activeDataset,
                    'gene_name':this.searchGene
                    }
                })
                .then(response=> {      
                    loadingInstance.close();
                    if(this.activePane=='gene'){
                        this.title=this.activeDataset+":"+this.searchGene
                        this.jsonData=response.data
                        
                    }  
                })
                .catch(error=> {
                    loadingInstance.close();
                    console.log(error);
                });
            }else{
                var loadingInstance = Loading.service({
                    target:document.querySelector('#boxplotMethylation')
                });
                this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/methylation',{
                params: { 
                    'geo':this.activeDataset,
                    'probe_id':this.searchMethylation
                    }
                })
                .then(response=> {    
                    loadingInstance.close(); 
                    if(this.activePane=='methylation'){
                        for(var key in response.data){
                            if(key=='gene_name')
                                this.title=this.activeDataset+":"+this.searchMethylation+" "+response.data[key]
                            else this.jsonData=response.data[key]
                        }
                    }
                    
                })
                .catch(error=> {
                    console.log(error);
                    loadingInstance.close();
                }); 
            }
            
        },
        map(){
            this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/methylation/map',{
            params: { 
                'geo':this.activeDataset,
                'gene_name':this.mapGene
                }
            })
            .then(response=> {      
                this.mapResult=response.data
            })
            .catch(error=> {
                console.log(error);
            });
        },
    },
   
})
</script>

<style>
.el-descriptions-item__cell{
  white-space: pre-line !important;
}
</style>
